import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../../../util/asyncComponent';


const Tools = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/sensor`}/>
            <Route path={`${match.url}/sensor`} component={asyncComponent(() => import('./routes/Sensor'))}/>
            <Route path={`${match.url}/gps  `} component={asyncComponent(() => import('./routes/GPS'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default Tools;


// WEBPACK FOOTER //
// ./app/routes/MasterData/routes/Tools/index.js